/**
 * Reports the document height to the host page so the `/d.js` loader can
 * auto-size the iframe (replaces the legacy iframe-resizer dependency).
 */
export function startResizeReporting() {
  if (window.parent === window) {
    return;
  }

  let lastHeight = 0;
  const post = () => {
    const height = document.documentElement.scrollHeight;
    if (height !== lastHeight) {
      lastHeight = height;
      window.parent.postMessage({ type: 'resize', height: `${height}px` }, '*');
    }
  };

  const observer = new ResizeObserver(post);
  observer.observe(document.documentElement);
  observer.observe(document.body);
  post();
}
